// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"checkBox_checkboxWrapper__MZSsP","input":"checkBox_input__fES8G","customBox":"checkBox_customBox__Lcjfw","label":"checkBox_label__T3Opf"};